import axios from "axios";

class API {
  constructor() {
    this.baseUrl = process.env.REACT_APP_API;
    this.apiUrl = process.env.REACT_APP_BASE;
    axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem('review_admin_token')}`;
  }

  async callAPI(method, url, data, callback) {
    try {
      const res = await method(`${this.baseUrl}${url}`, data);
      if (callback) {
        callback(null, res);
      }
      return res;
    } catch (error) {
      if (callback) {
        callback(error, null);
      }
      return error;
    }
  }

  async getAll(url, params = {}, callback = null) {
    return this.callAPI(axios.get, url, { params }, callback);
  }

  async getSingle(url, params, callback = null) {
    return this.callAPI(axios.get, `${url}/${params}`, {}, callback);
  }

  async create(url, data, callback = null) {
    return this.callAPI(axios.post, url, data, callback);
  }

  async update(url, params, data, callback = null) {
    return this.callAPI(axios.put, `${url}/${params}`, data, callback);
  }

  async remove(url, params, callback = null) {
    return this.callAPI(axios.delete, `${url}/${params}`, {}, callback);
  }

  async removeMany(url, data, callback = null) {
    return this.callAPI(axios.delete, url, { data }, callback);
  }
}

export default API;
